module.exports = __webpack_public_path__ + "img/horizontal_6_1_7042.00b4a4ad.png";